import React, { useEffect } from 'react';

interface UseHideGigObserverProps {
    targetRef: React.RefObject<HTMLElement>;
    callback: () => void;
}
/** Use the custom hook to observe the element and log when display: none !important is added */

const useHideGigObserver = ({ targetRef, callback }: UseHideGigObserverProps) => {
    useEffect(() => {
        // Ensure targetRef is not null and the DOM element is available
        if (targetRef.current) {
            const observer = new MutationObserver((mutationsList) => {
                // Iterate over mutations and call the callback when a 'display: none !important' is added
                for (const mutation of mutationsList) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                        const targetElement = mutation.target as HTMLElement;
                        const style = targetElement.style;
                        if (style && style.display === 'none' && style.getPropertyPriority('display') === 'important') {
                            callback();
                        }
                    }
                }
            });

            // Start observing the target element for changes to the 'style' attribute
            observer.observe(targetRef.current, {
                attributes: true,
                attributeFilter: ['style'],
            });

            // Cleanup observer on unmount
            return () => {
                observer.disconnect();
            };
        }
    }, [targetRef, callback]); // Re-run if targetRef or callback changes
};

export default useHideGigObserver;
